import React, { useEffect, useMemo, useState } from "react";
import styles from "./ProductStocks.module.scss";
import { Col, Row } from "react-bootstrap";
// import { CustomTable } from "../../tables/customTable/CustomTable";
import { TableCell, TableRow } from "@mui/material";
// import actions from "../../../../store/actions";
import { connect } from "react-redux";
// import { productStockData } from "../../../../datas/dashboardDummyData";
import { useDispatch } from "react-redux";
import { getAllCategory, getAllProductByCategoryId, getProductByCategoryId } from "../../../store/actions";
import { GenCustomTable } from "../../customComponents/genCustomTable/GenCustomTable";
import { Center } from "devextreme-react/map";
// import { getAllCategory } from "../../../store/actions";

export const ProductStocks = ({
  categories = [],
  maxHeight,
  productbyCategoryId = [],
  allProductsByCategory =[],
}) => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState(categories[0]?.id);
  //   const [rows, setRows] = useState([]);

  useEffect(() => {
    dispatch(getAllCategory());
  }, []);

  const columns = [
    { id: 1, label: "Product Name", minWidth: 170, align: "center" },
    { id: 2, label: "Product Id", minWidth: 170, align: "center" },
    { id: 3, label: "Qty", minWidth: 170, align: "center" },
  ];

  const getStructuredRows = (data = []) => {
    return data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "center",
            // marginLeft : "38%",
          }}
        >
          <div
            style={{
              borderRadius: "50%",
              height: "50px",
              width: "50px",
              overflow: "hidden",
            }}
          >
            <img
              src={item?.imageUrl}
              alt="profile"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </div>
          <span>{item?.name}</span>
        </div>,
        item?.productCode,
        item?.quantity,
      ],
    }));
  };

  //   const columns = useMemo(() => {
  //     const prod =
  //       productStockDatas.find((product) => product.id === selectedProduct) || {};
  //     return prod.columns || [];
  //   }, [selectedProduct]);

  //   useEffect(() => {
  //     if (selectedProduct) {
  //       setRows(getProductsData(products));
  //     }
  //   }, [products, selectedProduct]);

  //   const getProductsData = (data) => {
  //     switch (selectedProduct) {
  //       case "01":
  //         return data.plates;
  //       case "02":
  //         return data.thirdStickers;
  //       case "03":
  //         return data.hotFoils;
  //       case "04":
  //         return data.snapLocks;
  //       case "05":
  //         return data.frames;
  //       default:
  //         return;
  //     }
  //   };

  //   useEffect(() => {
  //     const fetchProductData = async () => {
  //       switch (selectedProduct) {
  //         case "01":
  //           getAllProducts();
  //           break;
  //         case "02":
  //           getAllThirdStickerProducts();
  //           break;
  //         case "03":
  //           getAllHotFoil();
  //           break;
  //         case "04":
  //           getAllSnapLock();
  //           break;
  //         case "05":
  //           getAllFrames();
  //           break;
  //         default:
  //           break;
  //       }
  //     };
  //     fetchProductData();
  //   }, [selectedProduct, DataLoad === true]);
  console.log(categories);
  const handleSelectedItem = (id) => {
    setSelectedProduct(id);

    //need to change this api call also contain the inactive products or need to do new api call 
    dispatch(
      getAllProductByCategoryId({
        id: id,
        callback: {
          success: (data) => console.log(data),
        },
      })
    );
  };

  useEffect(() => {
    dispatch(
      getAllProductByCategoryId({
        id: selectedProduct,
        callback: {
          success: (data) => console.log(data),
        },
      })
    );
  }, []);
  console.log(allProductsByCategory, "allProductsByCategory");

  return (
    <div className={styles.container}>
      <Row className={styles.productImageRow}>
        {categories.map((product) => (
          <Col
            className={`${styles.productImageContainer} ${
              product.id === selectedProduct ? styles.active : ""
            }`}
            key={product.id}
            onClick={() => handleSelectedItem(product?.id)}
          >
            <img
              src={product.imageUrl}
              alt={product.title}
              className={styles.productImage}
              title={product.title}
            />
          </Col>
        ))}
      </Row>
      {/* <CustomTable columns={columns} maxHeight={maxHeight}>
        {rows.map((row) => {
          return (
            <TableRow className={styles.bodyRow} key={row.id}>
              {columns.map((column) => {
                // console.log(column);
                const objectKey = column?.key;
                switch (column?.type) {
                  case "image":
                    return (
                      <TableCell className={styles.bodyCol}>
                        <img
                          src={row[objectKey]}
                          alt=""
                          className={styles.itemImage}
                        />
                      </TableCell>
                    );

                  default:
                    return (
                      <TableCell className={styles.bodyCell}>
                        {row[objectKey]}
                      </TableCell>
                    );
                }
              })}
            </TableRow>
          );
        })}
      </CustomTable> */}
      <div className={styles.bottom}>
        <div className={styles.bottomContent}>
          '{" "}
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(
              allProductsByCategory?.length > 0 ? allProductsByCategory : []
            )}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    categories: state?.category?.categories,
    // productbyCategoryId: state?.product?.productsByCategory,
    allProductsByCategory : state?.product?.allProductsByCategory
  };
};
export default connect(mapStateToProps, null)(ProductStocks);
